import { render, staticRenderFns } from "./VResponsive.vue?vue&type=template&id=a60704c2&"
import script from "./VResponsive.vue?vue&type=script&lang=js&"
export * from "./VResponsive.vue?vue&type=script&lang=js&"
import style0 from "./VResponsive.vue?vue&type=style&index=0&id=a60704c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports